export default __webpack_public_path__ + "static/media/hero-cloud3.2dcf478d.svg";